import { DataBean } from "../DataBean";

export class ContractModifyType extends DataBean {


    public async getContractModifyTypeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getContractModifyTypeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

 

}